import { render, staticRenderFns } from "./UserContributionsForm.vue?vue&type=template&id=4803e6b8&scoped=true&"
import script from "./UserContributionsForm.vue?vue&type=script&lang=js&"
export * from "./UserContributionsForm.vue?vue&type=script&lang=js&"
import style0 from "./UserContributionsForm.vue?vue&type=style&index=0&id=4803e6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4803e6b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VDivider,VSelect,VTextarea})
